module.exports = __webpack_public_path__ + "img/breadcrumb-arrow-right-16x16.87168a4e.svg";